import { EncodeQueryData, getRequestCityFromId, getUintFromRequestId } from '../helpers/miscHelpers';
import { loginPathForCurrentPage } from '../helpers/loginRedirect';
import { config } from './config';
import { getTrfAccessToken, clearTrfAccessToken } from './trfService';

function getIncomingApiKey() {
  const urlToken = new URLSearchParams(window.location.search).get('token');
  return urlToken || sessionStorage.getItem('token') || '';
}

export async function omsFetch(fwdRoute, fwdMethod, {
  body,
  queryParams = {},
  serviceUserTag = 'MedicPortal',
  emedicAuth = false,
} = {}) {
  const params = { ...queryParams };
  if (serviceUserTag) {
    params.serviceUserTag = serviceUserTag;
  }
  const paramUrl = EncodeQueryData(params);
  const headers = new Headers({
    Accept: 'application/json',
    'fwd-route': fwdRoute,
    'fwd-method': fwdMethod,
  });
  if (emedicAuth) {
    const accessToken = getTrfAccessToken();
    if (!accessToken) {
      window.location.assign(loginPathForCurrentPage());
      throw new Error('Missing access token');
    }
    headers.set('Authorization', `Bearer ${accessToken}`);
  } else {
    headers.set('incoming_api_key', getIncomingApiKey());
  }
  if (body && !(body instanceof FormData)) {
    headers.set('Content-Type', 'application/json');
  }
  const fetchOptions = {
    method: 'POST',
    headers,
  };
  if (body !== undefined) {
    fetchOptions.body = body;
  }
  const res = await fetch(`${config().apiHost}/api/cmp/route/oms?${paramUrl}`, fetchOptions);
  if (emedicAuth && res.status === 401) {
    clearTrfAccessToken();
    window.location.assign(loginPathForCurrentPage());
  }
  return res;
}

export async function SubmitVitalsToOms(
  orderId,
  cityCode,
  bpSys,
  bpDia,
  bpm,
  temp,
  spo2,
  height,
  weight,
  bmi,
) {
  const vitals = {
    bpSys: bpSys || undefined,
    bpDia: bpDia || undefined,
    bpm: bpm || undefined,
    temp: temp || undefined,
    spo2: spo2 || undefined,
    height: height || undefined,
    weight: weight || undefined,
    bmi: bmi || undefined,
  };

  const res = await omsFetch(
    `/api/collection-portal/${orderId}/vitals`,
    'POST',
    { queryParams: { cityCode }, body: JSON.stringify(vitals) },
  );

  if (res.ok) {
    return res.json();
  }
  throw new Error(res.status);
}

export async function MarkSamplesAccessioned(cityCode, accessionId) {
  const res = await omsFetch(
    '/api/collection-portal/accession-sample',
    'POST',
    { queryParams: { cityCode, accessionId } },
  );
  if (res.status === 200) {
    return res.json();
  }
  throw Error(res.status);
}

export async function GetMembersWithTestsList(task_id, requestId) {
  const cityCode = getRequestCityFromId(requestId);
  const res = await omsFetch(
    '/api/collection-portal/tat-by-task',
    'GET',
    { queryParams: { taskId: task_id, cityCode, limit: 100 } },
  );
  if (res.status === 200) {
    return res.json();
  }
  throw Error(res.status);
}

export async function SubmitVolumeToOms(requestId, accession_id, volume) {
  const cityCode = getRequestCityFromId(requestId);
  const res = await omsFetch(
    '/api/collection-portal/add-vial-volume',
    'POST',
    {
      queryParams: { cityCode },
      body: JSON.stringify({
        accession_id,
        volume,
      }),
    },
  );
  if (res.status === 200) {
    return res.json();
  }
  throw Error(res.status);
}

export async function GetAccessionsByRequestId(requestId) {
  const cityCode = getRequestCityFromId(requestId);
  const reqIdInt = getUintFromRequestId(requestId);
  const res = await omsFetch(
    '/api/collection-portal/request-accession',
    'GET',
    { queryParams: { requestId: String(reqIdInt), cityCode } },
  );
  if (res.status === 200) {
    return res.json();
  }
  throw Error(res.status);
}

export async function GetCacheVersion() {
  const res = await omsFetch(
    '/api/collection-portal/public/cache-version',
    'GET',
    { queryParams: { cityCode: 'BLR' }, serviceUserTag: false },
  );
  if (res.status === 200) {
    return res.json();
  }
  throw Error(res.status);
}
